(() => {
  const initializeParelliLevels = (root = document) => {
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    root.querySelectorAll("[data-lv-scroll]").forEach((link) => {
      if (link.dataset.lvBound === "true") return;
      link.dataset.lvBound = "true";
      link.addEventListener("click", (event) => {
        const href = link.getAttribute("href");
        if (!href || !href.startsWith("#")) return;
        const target = document.querySelector(href);
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion.matches ? "auto" : "smooth" });
      });
    });

    const revealItems = root.querySelectorAll("[data-reveal]");
    if (reducedMotion.matches || !("IntersectionObserver" in window)) {
      revealItems.forEach((item) => item.classList.add("is-visible"));
    } else {
      const revealObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add("is-visible");
            revealObserver.unobserve(entry.target);
          });
        },
        { threshold: 0.14 }
      );
      revealItems.forEach((item) => {
        if (!item.classList.contains("is-visible")) revealObserver.observe(item);
      });
    }

    root.querySelectorAll("[data-faq-button]").forEach((button) => {
      if (button.dataset.lvBound === "true") return;
      button.dataset.lvBound = "true";
      button.addEventListener("click", () => {
        const panel = document.getElementById(button.getAttribute("aria-controls"));
        const expanded = button.getAttribute("aria-expanded") === "true";
        button.setAttribute("aria-expanded", String(!expanded));
        if (panel) panel.hidden = expanded;
      });
    });

    root.querySelectorAll("[data-lv-variant-select]").forEach((select) => {
      if (select.dataset.lvBound === "true") return;
      select.dataset.lvBound = "true";
      select.addEventListener("change", () => {
        const option = select.options[select.selectedIndex];
        const card = select.closest(".lv-offer__card");
        const price = card && card.querySelector("[data-lv-price]");
        if (!price || !option) return;
        price.innerHTML = `<span>${option.dataset.price || ""}</span>${option.dataset.compare ? `<del>${option.dataset.compare}</del>` : ""}`;
      });
    });

    const hero = document.querySelector("[data-hero]");
    const offer = document.querySelector("[data-offer]");
    const sticky = document.querySelector("[data-sticky]");
    if (hero && offer && sticky && sticky.dataset.lvBound !== "true") {
      sticky.dataset.lvBound = "true";
      const updateSticky = () => {
        const afterHero = hero.getBoundingClientRect().bottom < 80;
        const atOffer = offer.getBoundingClientRect().top < window.innerHeight * 0.8;
        sticky.classList.toggle("is-visible", afterHero && !atOffer);
      };
      window.addEventListener("scroll", updateSticky, { passive: true });
      updateSticky();
    }
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeParelliLevels());
  } else {
    initializeParelliLevels();
  }

  document.addEventListener("shopify:section:load", (event) => initializeParelliLevels(event.target));
})();
